export enum EReportsTableKeys {
  LATEST_TRANSACTIONS = "latest-transactions-table",
  MONTHLY_TRANSACTIONS = "monthly-transactions-table",
  CATEGORY_TRANSACTIONS = "category-transactions-table",
  CLIENT_PROVIDER_TRANSACTIONS = "client-provider-transactions-table",
  PAYMENT_METHOD_TRANSACTIONS = "payment-methods-table",
  STATUS_TRANSACTIONS = "status-transactions-table",
}

export enum ETransactionsTableKeys {
  ACTIVE_TRANSACTIONS = "active-transactions-table",
  ARCHIVED_TRANSACTIONS = "archived-transactions-table",
  RECYCLED_TRANSACTIONS = "recycled-transactions-table",
  TRANSACTION_DETAILS = "transaction-details-table",
  RECURRING_TRANSACTIONS = "recurring-transactions-table",
}

export enum EAttachmentsTableKeys {
  ATTACHMENTS_SELECTOR = "attachments-selector-table",
  ATTACHMENTS_LIST = "attachments-list-table",
}

export enum ESourcesTableKeys {
  SOURCES_LIST = "sources-list-table",
}

export enum ECategoriesTableKeys {
  CATEGORIES_LIST = "categories-list-table",
}

export enum EPaymentMethodsTableKeys {
  BULTIN_PAYMENT_METHODS = "built-in-payment-methods-table",
  CUSTOM_PAYMENT_METHODS = "custom-payment-methods-table",
}

export enum EContactInvitesTableKeys {
  RECEIVED_INVITES = "received-invites-table",
}
